import React, { useEffect, useState } from 'react';
import { auth, db } from '../firebase';
import {
  collection,
  getDocs,
  query,
  where,
  doc,
  setDoc,
  serverTimestamp,
  getDoc,
} from 'firebase/firestore';
import { supabase } from './supabaseClient';
import defaultUser from './user-default.png';
import '../App.css';
import { useRole } from './RoleContext';
import UserProfile from './UserProfile';

function MentorSearch() {
  const [mentors, setMentors] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(false);
  const { role } = useRole();
  const [user, setUser] = useState(null);
  const [fullNameInput, setFullNameInput] = useState('');
  const [viewingUserId, setViewingUserId] = useState(null);
  console.log(fullNameInput)

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(u => {
      setUser(u);
      if (u) {
        const fetchUserFullName = async uid => {
          try {
            const userDoc = await getDoc(doc(db, 'users', uid));
            if (userDoc.exists()) {
              setFullNameInput(userDoc.data().fullName || '');
            }
          } catch (err) {
            console.error('Error fetching user full name:', err);
          }
        };
        fetchUserFullName(u.uid);
      }
    });
    return unsubscribe;
  }, []);

  const fetchMentors = async () => {
    setLoading(true);
    try {
      const q = query(
        collection(db, 'users'),
        where('role', '==', 'mentor'),
        where('emailVerified', '==', true)
      );
      const snapshot = await getDocs(q);
      const list = await Promise.all(
        snapshot.docs.map(async d => {
          const data = d.data();
          const profileUrlData = supabase.storage
            .from('profile-pictures')
            .getPublicUrl(`profile-pictures/${d.id}/profile.jpg`);
          return {
            id: d.id,
            skills: Array.isArray(data.skills)
              ? data.skills
              : typeof data.skills === 'string'
              ? data.skills.split(',').map(s => s.trim())
              : [],
            fullName: data.fullName || 'Unnamed',
            profileUrl: profileUrlData.data.publicUrl
          };
        })
      );
      setMentors(list);
    } catch (err) {
      console.error('Error fetching mentors:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMentors();
  }, []);

  const requestMentor = async mentor => {
    if (!user) {
      alert('Please log in to request a mentor.');
      return;
    }
    const requestId = `${mentor.id}__${user.uid}`;
    try {
      await setDoc(doc(db, 'mentorRequests', requestId), {
        mentorId: mentor.id,
        requesterId: user.uid,
        status: 'pending',
        createdAt: serverTimestamp()
      });
      alert(`Requested mentor ${mentor.fullName}.`);
    } catch (err) {
      console.error('Error requesting mentor:', err);
      alert('Failed to send request.');
    }
  };

  const filtered = searchTerm
    ? mentors.filter(m =>
        m.skills.some(s => s.toLowerCase().includes(searchTerm.toLowerCase()))
      )
    : mentors;

  if (viewingUserId) {
    return <UserProfile userId={viewingUserId} setPage={() => setViewingUserId(null)} />;
  }

  return (
    <div className="mentor-search-container">
      <h2 className="mentor-search-header">Find Your Mentor</h2>

      <div className="mentor-search-bar">
        <input
          type="search"
          placeholder="Search by skill..."
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
        />
        <i className="bi bi-search search-icon"></i>
      </div>

      {loading && <p style={{ textAlign: 'center', marginTop: '20px' }}>Loading mentors...</p>}

      <div className="mentor-grid">
        {filtered.length > 0 ? (
          filtered.map(m => (
            <div
              key={m.id}
              className="mentor-card"
              onClick={() => setViewingUserId(m.id)}
            >
              <img
                src={m.profileUrl || defaultUser}
                alt="Profile"
                className="mentor-profile"
              />
              <h3 className="mentor-name">{m.fullName}</h3>
              <div className="mentor-skills">
                {m.skills.length > 0
                  ? m.skills.map((sk, i) => (
                      <span key={i} className="skill-chip">{sk}</span>
                    ))
                  : <span className="no-skills">No skills listed</span>}
              </div>
              {role === 'mentee' && (
                <button
                  className="request-btn"
                  onClick={e => {
                    e.stopPropagation();
                    requestMentor(m);
                  }}
                >
                  Request Mentor
                </button>
              )}
            </div>
          ))
        ) : (
          !loading && <p style={{ textAlign: 'center', marginTop: '20px' }}>No mentors found for that skill. Try a different term.</p>
        )}
      </div>
    </div>
  );
}

export default MentorSearch;

